import { render, staticRenderFns } from "./WorkHistoryDetails.vue?vue&type=template&id=4e37f413&"
import script from "./WorkHistoryDetails.vue?vue&type=script&lang=js&"
export * from "./WorkHistoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./WorkHistoryDetails.vue?vue&type=style&index=0&id=4e37f413&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports